module.exports = __webpack_public_path__ + "static/media/PictoMotorEmbraiagem_2pt.ed194a42.svg";